export default __webpack_public_path__ + "media/images/gallery/timeline-7c198bcc93b57f24aa34521960e88e83.jpg";